module.exports = __webpack_public_path__ + "static/img_beneficios-7b7c39fda1f2eca79859455d97b71119.png";